import * as SUGA from 'suga';

/**
 * Foreground visualization of the data that model contains.
 */
export default class View extends PIXI.Container
    {
    /**
     * Initialize
     *
     * @param  {Object}  images  The images
     */
    init(images)
    {
        this.z = 2;

        const handTextures = SUGA.Loader.makeTexturesFromName('hand');

        this.hand = new PIXI.extras.AnimatedSprite(handTextures);
        this.addChild(this.hand);
        this.hand.x = 10;
        this.hand.y = 5;
        this.hand.scale.set(1.2)
        this.hand.play();
        this.hand.animationSpeed = 0.1;

        this.character = new PIXI.Sprite.fromImage(images.char);
        this.addChild(this.character);
        this.character.x = 55;

    }
}




// WEBPACK FOOTER //
// ./themes/fq/view/menu-view.js